import DocViewer, { DocViewerRenderers } from "@cyntler/react-doc-viewer";
import ReactPlayer from "react-player";
import ReactAudioPlayer from "react-audio-player";

import { useState } from "react";
import { useEffect } from "react";
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";
import { GetParameterByName } from "../../lib/utils";

function FilePreviewComponent() {
  const [url, setUrl] = useState("");

  useEffect(() => {
    let fileUrl = "";
    if (GetParameterByName("file")) {
      if (GetParameterByName("node")) {
        fileUrl = fileUrl.concat(GetParameterByName("node"));
      }

      fileUrl = window["appConfig"]()
        ["fileRoot"]()
        .concat(fileUrl.concat(GetParameterByName("file")));

      fileUrl = fileUrl.replaceAll("//", "/");
    }

    setUrl(fileUrl);
  }, []);

  const filePreview = () => {
    let previewWrapper = [];

    let ext = url.split(".");
    ext = ext[ext.length - 1].toLowerCase();

    switch (ext) {
      case "mp4":
        previewWrapper = (
          <div className="player-wrapper h-100">
            <ReactPlayer
              className="react-player"
              url={url}
              width="100%"
              height="100%"
              controls="true"
            />
          </div>
        );
        break;

      case "mpeg":
        previewWrapper = (
          <div className="w-100 h-100">
            <ReactAudioPlayer
              src={url}
              autoPlay
              controls
              className="d-block m-auto mt-5"
            />
          </div>
        );
        break;

      default:
        previewWrapper = (
          <div className="w-100 h-100">
            <DocViewer
              config={{
                header: {
                  disableHeader: true,
                  disableFileName: true,
                  retainURLParams: false,
                },
                csvDelimiter: ",", // "," as default,
                pdfZoom: {
                  defaultZoom: 0.4, // 1 as default,
                  zoomJump: 0.2, // 0.1 as default,
                },
              }}
              pluginRenderers={DocViewerRenderers}
              documents={[{ uri: url }]}
            />
          </div>
        );

        break;
    }

    return <div className="wrapper w-100 p-2">{previewWrapper}</div>;
  };

  return filePreview();
}
export default FilePreviewComponent;
